<template>
    <div :id="modalId" uk-modal>
        <div class="uk-modal-dialog-blank uk-modal-body">
            <div class="uk-grid table-filter">
                <div class="uk-width-1-4@xl uk-width-1-2@s uk-margin-small-bottom">
                    <label for="pf-search" class="uk-form-label">Search</label>
                    <div class="uk-form-controls">
                        <input id="pf-search" type="text" name="pf-search" value="" class="uk-input" @keyup.enter="startSearch" v-model="searchTerm" placeholder="Enter Search Terms" />
                    </div>
                    <div v-if="!activeSearch" class="uk-form-label uk-margin-top">Narrow Search By</div>
                    <div v-if="!activeSearch" class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                        <label>
                            Name
                            <input class="uk-checkbox" type="checkbox" value="name" v-model="checkedFilters" />
                        </label>
                        <label>
                            Reg. #
                            <input class="uk-checkbox" type="checkbox" value="emp" v-model="checkedFilters" />
                        </label>
                        <label>
                            Craft
                            <input class="uk-checkbox" type="checkbox" value="craft" v-model="checkedFilters" />
                        </label>
                        <label>
                            Certification
                            <input class="uk-checkbox" type="checkbox" value="certification" v-model="checkedFilters" />
                        </label>
                        <label>
                            Training
                            <input class="uk-checkbox" type="checkbox" value="training" v-model="checkedFilters" />
                        </label>
                        <label>
                            Phone #
                            <input class="uk-checkbox" type="checkbox" value="phone" v-model="checkedFilters" />
                        </label>
                    </div>

                    <div v-if="activeSearch" class="uk-form-label uk-margin-top">Search By:</div>
                    <div v-if="activeSearch" class="uk-margin uk-grid-medium uk-child-width-auto uk-grid">
                        <div class="uk-width-1-2@l">
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="name" v-model="selectedFilter" />
                                Name
                            </label>
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="emp" v-model="selectedFilter" />
                                Employee #
                            </label>
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="ssn" v-model="selectedFilter" />
                                SSN (Last 4)
                            </label>
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="craft" v-model="selectedFilter" />
                                Craft
                            </label>
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="certification" v-model="selectedFilter" />
                                Certification
                            </label>
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="training" v-model="selectedFilter" />
                                Training
                            </label>
                            <label class="uk-display-block">
                                <input class="uk-radio" type="radio" value="phone" v-model="selectedFilter" />
                                Phone #
                            </label>
                        </div>
                        <div class="uk-width-1-2@l ">
                            <button v-if="!searching" class="uk-button uk-button-primary uk-align-right" @click="startSearch">
                                Search
                            </button>
                            <span v-if="searching" class="uk-align-right">
                            <img style="width: 18px;" src="/images/spinner2.gif" /> Searching...
                        </span>
                        </div>
                        <div class="uk-width-1-2@l">
                            <label>
                                Include Deleted
                                <input class="uk-checkbox" type="checkbox" v-model="includeDeleted" />
                            </label>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-3@xl uk-width-1-2@s uk-margin-small-bottom">
                    <div class="uk-form-label">Filter</div>
                    <div>
                        Craft:
                        <div class="uk-select uk-margin-small-left uk-width-3-4" style="display:inline-block">SELECT CRAFTS</div>
                        <div uk-dropdown>
                            <div v-for="val in craftOptions">
                                <label><input :key="'craft_' + val.id" class="uk-checkbox" type="checkbox" :value="val.id"
                                              v-model="craftIds"> {{ val.name }}</label>
                            </div>
                        </div>

                    </div>
                    <div class="uk-margin-top">
                        Business Unit:
                        <div class="uk-select uk-margin-small-left uk-width-2-3" style="display:inline-block">SELECT BUSINESS UNIT</div>
                        <div uk-dropdown>
                            <div v-for="val in buOptions">
                                <label><input :key="'craft_' + val.id" class="uk-checkbox" type="checkbox" :value="val.id"
                                              v-model="buIds"> {{ val.name }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="uk-margin-top">
                        State:
                        <select class="uk-select uk-width-auto" v-model="state">
                            <option value="">-- Select State --</option>
                            <option v-for="(name, code) in states" :value="code">{{ name }}</option>
                        </select>
                    </div>
                </div>
                <div class="uk-width-1-6@xl uk-width-1-2@s uk-margin-small-bottom">
                    <div class="uk-form-controls">
                        <input id="pf-category" type="text" name="pf-category" value="" class="uk-input" v-model="searchCategory" placeholder="Enter Rating Type" />
                    </div>
                    <div class="uk-margin-top">
                        Rating:
                        <select class="uk-select uk-width-1-4" v-model="lowRating">
                            <option v-for="val in ratingValues" :value="val" >{{val}}</option>
                        </select>
                        <select class="uk-select uk-width-1-4" v-model="highRating">
                            <option v-for="val in ratingValues" :value="val" >{{val}}</option>
                        </select>
                    </div>
                    <div class="uk-form-label">Records Per Page</div>
                    <select class="uk-select uk-width-1-4" v-model="perPage">
                        <option v-for="val in recordOptions" :value="val" >{{val}}</option>
                    </select>
                    <div class="uk-margin-top">
                        <button class="uk-button uk-button-small uk-margin-small-bottom" @click="clearFilters()">Clear Search/Filters</button>
                    </div>
                    <div v-if="isAdmin" class="uk-margin-top">
                        <label>
                            Show All
                            <input class="uk-checkbox" type="checkbox" value="true" v-model="disableBusy" />
                        </label>
                    </div>
                </div>
                <div class="uk-width-1-4@xl uk-width-1-2@s uk-text-right">
                    <button v-if="assignMultiple" @click="checkPlacements" class="uk-button uk-button-tertiary uk-margin-small-bottom uk-modal-close"><i class="fas fa-user-check"></i>Place</button>
                    <button class="uk-button uk-button-tertiary uk-margin-small-bottom uk-modal-close"><i class="fas fa-times-circle"></i>{{ this.assignMultiple ? "Cancel":"Close" }}</button>
                </div>
            </div>
            <data-table
                    ref="personTable"
                    :searchable="false"
                    api_point="employee/list"
                    :per_page="perPage"
                    :table_headers="tableHeaders"
                    :multi_select="assignMultiple"
            ></data-table>
        </div>
    </div>
</template>

<script>
    // import any required components
    import DataTable from "../Table/DataTable";
    import PlaceButton from "./PlaceButton";
    import EventBus from "../../events.js";
    import _ from 'lodash';
    import GlobalStorage from "../../Classes/GlobalStorage";
    import Format from "../../Classes/Format";

    // export component
    export default {
        props: {
            modalId:String,
            formRef:String,
            isAdmin:Boolean,
			displayHours:{type:Boolean, default:false},
            activeSearch:{type:Boolean, default:true},
        },

        components: {
            DataTable,
            PlaceButton,
            EventBus
        },

        data() {
            return {
                useAPI: true,
                perPage: 30,
                ratingValues: [1,2,3,4,5],
                lowRating: 1,
                highRating: 5,
                recordOptions: [10,15,30,50],
                buOptions: [],
                buIds:[],
                craftIds: [],
                craftId: 0,
                craftOptions: [],
                checkedFilters: [],
                selectedFilter:"name",
                includeDeleted: false,
                searching: false,
                searchTerm: "",
                searchCategory: "",
                typeCount: 0,
                assignMultiple: false,
                requestId: 0,
                tableHeaders:{
					id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:'paylocity_number'},
					full_name:{display:'Employee Name',route:'/employees/view/{id}'},
					phone:{display:'Contact Phone'},
					"location.city":{display:'City', sortable: false},
					"location.state": {display:'ST', sortable: false},
					crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
					certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
					"business_unit.name": {display:'Business Unit', sortable: false},
					available_date: {display:'Availability', sortable: false},
					average_rating: {display:'Rating'},
					notes: {display: 'Notes',sortable: false}
                },
                states:{},
                state:"",
                disableBusy:false
            };
        },

        mounted(){
			if(this.displayHours){
				this.tableFields = {id_number:{display:'Employee Number',route:'/employees/view/{id}',sortBy:'paylocity_number'},
					full_name:{display:'Employee Name',route:'/employees/view/{id}'},
					phone:{display:'Contact Phone'},
					"location.city":{display:'City', sortable: false},
					"location.state": {display:'ST', sortable: false},
					crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
					certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
					"business_unit.name": {display:'Business Unit', sortable: false},
					total_hours: {display:'Worked Hours'},
					available_date: {display:'Availability', sortable: false},
					average_rating: {display:'Rating'},
					notes: {display: 'Notes',sortable: false}
				}
			}
            this.loadCrafts();
            this.loadStates();
            this.loadBusinessUnits();
            this.loadCrafts();
            EventBus.addEventListener("placement-chosen", (id) => this.checkPlacements(id));
            this.$refs.personTable.setPreSearchCallback(this.searchStarting);
            this.$refs.personTable.setSearchCallback(this.searchComplete);
        },

        methods: {
            startSearch(){
                this.$refs.personTable.startCustomSearch(
					{
						"q": this.searchTerm,
						"filters": this.checkedFilters,
						"ratingCategory": this.searchCategory,
						"lowRating": this.lowRating,
						"highRating": this.highRating,
						"craftIds": this.craftIds,
						"buIds": this.buIds,
						"state": this.state,
						"requestId": this.requestId,
						disableBusy: this.disableBusy ? true : false
					});
            },
            searchStarting(){
                this.searching = true;
            },
            searchComplete(){
                this.searching = false;
            },
            apiSearch(){
                this.typeCount--;
                if(this.typeCount <= 0){
                    this.startSearch();
                }
            },
            clearFilters(){
                this.searchTerm = "";
                this.checkedFilters = [];
                this.searchCategory = "";
                this.lowRating = 1;
                this.highRating = 5;
                this.buIds = [];
                this.craftIds = [];
                this.state = "";
				this.$refs["personTable"].clearStorage();
                GlobalStorage.save(this.storageName, null); //force clearing out in case it gets "stuck"
            },
            loadBusinessUnits(){
                axios.get("/api/bu/list")
                    .then((pack) => this.updateBuData(pack));
            },
            loadCrafts(){
                axios.get("/api/craft/list/all")
                    .then((pack) => this.updateCraftData(pack));
            },
            placeSingle(id){
                this.assignMultiple = false;
                this.requestId = id;
                this.$refs.personTable.selectedRows = [];
                if(this.displayHours){
                	this.tableHeaders = {
						id_number:{display:'Employee Number',route:'/employees/view/{id}',target:'_blank',sortBy:'paylocity_number'},
						full_name:{display:'Employee Name',route:'/employees/view/{id}',target:'_blank'},
						phone:{display:'Contact Phone'},
						"location.city":{display:'City', sortable: false},
						"location.state": {display:'ST', sortable: false},
						crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
						certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
						"business_unit.name": {display:'Business Unit', sortable: false},
						total_hours: {display:'Worked Hours'},
						available_date: {display:'Availability', sortable: false},
						average_rating: {display:'Rating'},
						notes: {display: 'Notes',sortable: false},
						id: {display: '', component: PlaceButton, sortable:false}
					};
				} else {
                	this.tableHeaders = {
						id_number:{display:'Employee Number',route:'/employees/view/{id}',target:'_blank',sortBy:'paylocity_number'},
						full_name:{display:'Employee Name',route:'/employees/view/{id}',target:'_blank'},
						phone:{display:'Contact Phone'},
						"location.city":{display:'City', sortable: false},
						"location.state": {display:'ST', sortable: false},
						crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
						certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
						"business_unit.name": {display:'Business Unit', sortable: false},
						available_date: {display:'Availability', sortable: false},
						average_rating: {display:'Rating'},
						notes: {display: 'Notes',sortable: false},
						id: {display: '', component: PlaceButton, sortable:false}
					};
				}

                this.startSearch();
            },
            placeMultiple(id){
                this.assignMultiple = true;
                this.requestId = id;
                this.$refs.personTable.selectedRows = [];
				if(this.displayHours){
					this.tableHeaders = {
						id_number:{display:'Employee Number',route:'/employees/view/{id}',target:'_blank',sortBy:'paylocity_number'},
						full_name:{display:'Employee Name',route:'/employees/view/{id}',target:'_blank'},
						phone:{display:'Contact Phone'},
						"location.city":{display:'City', sortable: false},
						"location.state": {display:'ST', sortable: false},
						crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
						certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
						"business_unit.name": {display:'Business Unit', sortable: false},
						total_hours: {display:'Worked Hours'},
						available_date: {display:'Availability', sortable: false},
						average_rating: {display:'Rating'},
						notes: {display: 'Notes',sortable: false}
					};
				} else {
					this.tableHeaders = {
						id_number:{display:'Employee Number',route:'/employees/view/{id}',target:'_blank',sortBy:'paylocity_number'},
						full_name:{display:'Employee Name',route:'/employees/view/{id}',target:'_blank'},
						phone:{display:'Contact Phone'},
						"location.city":{display:'City', sortable: false},
						"location.state": {display:'ST', sortable: false},
						crafts: {display:'Craft(s)', component: "NameClusterCell", sortable:false},
						certifications: {display:'Certification(s)', component: "NameClusterCell", sortable:false},
						"business_unit.name": {display:'Business Unit', sortable: false},
						available_date: {display:'Availability', sortable: false},
						average_rating: {display:'Rating'},
						notes: {display: 'Notes',sortable: false}
					};
				}

                this.startSearch();
            },
            checkPlacements(id = null){
                let selections = [];
                if(this.assignMultiple){
                    selections = this.$refs.personTable.selectedRows;
                } else if(!isNaN(id)) {
                    selections = [id];
                }
                axios.post("/api/requisition/check/" + this.requestId, {persons:selections})
                    .then((pack) => this.processChecks(pack));
            },
            processChecks(pack){
                if(pack.data.success){
                    let okIds = [];
                    let confirmChecks = [];
                    let personChecks = pack.data.data;
                    for(let i = 0; i < personChecks.length;++i){
                        let check = personChecks[i];
                        if(check.conflictCount == 0 &&
							!check.DNH && !check.probation && !check.is_inactive && !check.is_conditional){
                            okIds.push(check.employee.id);
                        } else {
                            confirmChecks.push(check);
                        }
                    }

                    //send on through the ones that don't need to be confirmed
                    if(okIds.length > 0){
                        this.submitPlacements(okIds);
                    }
                    if(confirmChecks.length > 0){
                        this.confirmEmployees(confirmChecks);
                    }
                } else {
                    UIkit.modal.alert("Sorry, you do not have the rights to assign this employee. Please discuss this addition to your manager and have them set the change.");
                }
            },
            //single start point for recursive method
            confirmEmployees(checks){
                this.confirmEmployee(checks, 0);
            },
            confirmEmployee(checks, ci){
                let check = checks[ci];
                let confirmText = "";

                if(check.DNH){
                    confirmText += "<div>"+check.employee.full_name+" is marked DNH</div>";
                    confirmText += "<div>\"Based off your previous work performance I’m not able to offer you employment at this time. This is all the information I have to share with you.\"</div>";
                }
				if(check.is_inactive){
					confirmText += "<div>"+check.employee.full_name+" is not currently active and should not be used.</div>";
				}
				if(check.is_conditional){
					confirmText += "<div>"+check.employee.full_name+" is a conditional rehire.</div>";
				}
                if(check.probation){
                    confirmText += "<div>"+check.employee.full_name+" is on probation until "
                        +Format.formatDate(check.probation.ending)
                        +"</div>";
                }
                if(check.conflicts.length > 0 || check.softConflicts.length > 0){
                    confirmText += "<div>"+check.employee.full_name+" has the following conflicts:</div>";
                    for(let i = 0; i < check.conflicts.length;++i){
                        let conflict = check.conflicts[i];
                        if(conflict.requisition.name.length == 0){
                            confirmText += "<div>"+ conflict.requisition.number +"</div>";
                        } else {
                            confirmText += "<div>"+ conflict.requisition.name + ": " + conflict.requisition.customer +"</div>";
                        }
                    }
					for(let i = 0; i < check.softConflicts.length;++i){
                        let conflict = check.softConflicts[i];
                        if(conflict.requisition.name.length == 0){
                            confirmText += "<div class='soft-conflict'>Is a candidate for "+ conflict.requisition.number +"</div>";
                        } else {
                            confirmText += "<div class='soft-conflict'>Is a candidate for "+ conflict.requisition.name + ": " + conflict.requisition.customer +"</div>";
                        }
                    }
                }

                confirmText +=  "<div style=\"margin-top: 5px;\">Do you want to add them anyway?</div>";
                UIkit.modal.confirm(confirmText).then(
                    () => this.confirmPlacement(check, checks, ci),
                    () => this.cancelPlacement(checks, ci)
                );
            },
            confirmPlacement(check, checks, ci){
                console.log("confirmed!", ci, check);
                this.submitPlacements([check.employee.id]);
                ci++;
                if(ci < checks.length){
                    this.confirmEmployee(checks, ci);
                }
            },
            cancelPlacement(checks, ci){
                console.log("cancelled!", ci);
                ci++;
                if(ci < checks.length){
                    this.confirmEmployee(checks, ci);
                }
            },
            submitPlacements(selections){
                axios.post("/api/requisition/assign/" + this.requestId, {persons:selections})
                    .then((pack) => this.placementsComplete(pack));
            },
            placementsComplete(pack){
                if(pack.data.success){
                    this.$refs.personTable.clearSelections();
                    this.$root.$refs[this.formRef].appendPlacements(this.requestId, pack.data.data);
                    this.$refs.personTable.startSearch();
                }else{
                    UIkit.modal.alert("Sorry, you do not have the rights to assign this employee. Please discuss this addition to your manager and have them set the change.");
                }
            },
            loadStates(){
                axios.get("/api/forms/states")
                    .then((pack) => this.updateStateList(pack));
            },
            updateStateList(pack) {
                if(pack.data.success){
                    this.states = pack.data.data;
                }
            },
            updateBuData(pack){
                let dt = pack.data.data;
                this.buOptions = dt;
            },
            updateCraftData(pack){
                let dt = pack.data.data;
                this.craftOptions = dt;
            },
            compileFilters(){
                this.checkedFilters = [this.selectedFilter];
                if(this.includeDeleted){
                    this.checkedFilters.push("include_deleted");
                }
            }
        },

        watch: {
            searchTerm() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }

            },
            searchCategory() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    //let this one be a little longer; will likely be intensive
                    setTimeout(() => this.apiSearch(), 600);
                } else {
                    this.startSearch();
                }
            },
            lowRating() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            highRating() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            checkedFilters() {
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            perPage() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            craftIds(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            buIds(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            state(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            disableBusy(){
                if(this.activeSearch){
                    return;
                }
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            selectedFilter(){
                this.compileFilters();
            },
            includeDeleted(){
                this.compileFilters();
            }
        }
    };

</script>
